import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import IconCommercial from '@pkgs/components/assets/icons/small/OfficeResidential.svg';
import IconResidential from '@pkgs/components/assets/icons/small/House.svg';
import IconDevelopment from '@pkgs/components/assets/icons/small/Development.svg';
import { PropertyMarketingType } from '@ev-tech/search-modules-api';

import { ObjectTypeFilterTab } from './ObjectTypeFilterTab';

import styles from './ObjectTypeFilter.module.css';

export const ObjectTypeFilterTabSelector = () => {
  const marketingType = useSearchStore((state) => state.marketingType);

  return (
    <div className={styles.tabSelector}>
      <ObjectTypeFilterTab category="residential" icon={<IconResidential />} />
      <ObjectTypeFilterTab category="commercial" icon={<IconCommercial />} />
      {marketingType === PropertyMarketingType.sale && <ObjectTypeFilterTab category="development" icon={<IconDevelopment />} />}
    </div>
  );
};
